/** Tải file SVG về máy. Ném lỗi nếu trình duyệt chặn tải tự động (ví dụ WebView Facebook). */
export function downloadSvg(svg: string, filename: string): void {
  const blob = new Blob([svg], { type: "image/svg+xml" });
  const url = URL.createObjectURL(blob);
  try {
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  } finally {
    setTimeout(() => URL.revokeObjectURL(url), 2000);
  }
}

/**
 * Chuyển SVG sang Blob PNG ngay trên trình duyệt (vẽ Image từ blob SVG lên canvas rồi toBlob).
 * Không dùng WebGL, chỉ Canvas 2D — chạy được trong WebView Facebook. Dùng chung cho tải trực
 * tiếp (downloadPngFromSvg) lẫn chuỗi fallback tải ảnh (src/env.ts downloadImageWithFallback)
 * và Web Share API (cần File/Blob thật, không phải data URL).
 */
export function svgToPngBlob(svg: string, scale = 2): Promise<Blob> {
  return new Promise((resolve, reject) => {
    const blob = new Blob([svg], { type: "image/svg+xml" });
    const url = URL.createObjectURL(blob);
    const img = new Image();

    img.onload = () => {
      try {
        const width = (img.width || 320) * scale;
        const height = (img.height || 320) * scale;
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        if (!ctx) throw new Error("no_canvas_context");
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, width, height);
        ctx.drawImage(img, 0, 0, width, height);

        canvas.toBlob((pngBlob) => {
          URL.revokeObjectURL(url);
          if (!pngBlob) {
            reject(new Error("to_blob_failed"));
            return;
          }
          resolve(pngBlob);
        }, "image/png");
      } catch (e) {
        URL.revokeObjectURL(url);
        reject(e as Error);
      }
    };

    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("image_load_failed"));
    };

    img.src = url;
  });
}

/** Chuyển SVG sang PNG rồi tải về máy ngay (dùng svgToPngBlob + thẻ `<a download>`). */
export function downloadPngFromSvg(svg: string, filename: string): Promise<void> {
  return svgToPngBlob(svg).then((pngBlob) => {
    const pngUrl = URL.createObjectURL(pngBlob);
    try {
      const a = document.createElement("a");
      a.href = pngUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    } finally {
      setTimeout(() => URL.revokeObjectURL(pngUrl), 2000);
    }
  });
}
